/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:44:35
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/actionSheet.js
 */
export default {
    // action-sheet组件
    actionSheet: {
        show: false,
        title: '',
        description: '',
        actions: () => [],
        index: '',
        cancelText: '',
        closeOnClickAction: true,
        safeAreaInsetBottom: true,
        openType: '',
        closeOnClickOverlay: true,
        round: 0
    }
}
